import React, { useRef } from "react"
import { storyblokEditable } from "gatsby-source-storyblok"
import { useStaticQuery, graphql } from "gatsby"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { Lang, LangEnum, Trans } from "../utils/lang"
import { Href } from "../utils/helper"

const PopularArticle = ({blok}) => {
  
  const { enBlogs, jaBlogs } = useStaticQuery(graphql`
  query {
    enBlogs: allStoryblokEntry(
      filter: {field_component: {eq: "blogArticle"}, field_popular_boolean: {eq: true}, full_slug: {regex: "/^blog/"}}
      sort: {published_at: DESC}
      limit: 12
    ) {
      edges {
        node {
          uuid
          name
          content
          full_slug
          slug
          published_at(formatString: "MM/DD/YYYY")
          first_published_at(formatString: "MM/DD/YYYY")
        }
      }
    }

    jaBlogs: allStoryblokEntry(
      filter: {field_component: {eq: "blogArticle"}, full_slug: {regex: "/^ja/blog/"}}
      sort: {published_at: DESC}
      limit: 12
    ) {
      edges {
        node {
          uuid
          name
          content
          full_slug
          slug
          published_at(formatString: "MM/DD/YYYY")
          first_published_at(formatString: "MM/DD/YYYY")
        }
      }
    } 
  } 
  `)
  const lang = Lang()
  const articles = lang === LangEnum.JA ? jaBlogs : enBlogs
  // console.log(articles)
  articles.edges.forEach((e) => {
    e.node.content = typeof e.node.content === 'string' ? JSON.parse(e.node.content) : e.node.content;
  })

  let sliderRef = useRef(null)
  const next = () => {
    sliderRef.current.slickNext()
  }
  const previous = () => {
    sliderRef.current.slickPrev()
  }

  const PrevArrow = (props) => {
    const { className, style, onClick } = props
    return (
      <button className={className} onClick={onClick}
        style={{ ...style, display: "block", width: "45px"}} >
        <img className="absolute top-0 left-0 w-[46px] h-[30px]" src="/icons/carousel-arrow-left.svg" alt="Prev button"/>
      </button>
    )
  }

  const NextArrow = (props) => {
    const { className, style, onClick } = props
    return (
      <button className={className} onClick={onClick}
        style={{ ...style, display: "block", width: "45px"}} >
        <img className="absolute top-0 right-0 w-[46px] h-[30px]" src="/icons/carousel-arrow-right.svg" alt="Next button"/>
      </button>
    )
  }
  
  const settings = {
    autoplay: false,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      { breakpoint: 1280, settings: { slidesToShow: 3, slidesToScroll: 3 } },
      { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint:  640, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ]
  }

  const articleItem = (blok, full_slug, post_date) => (
    <div className="px-3 md:px-4" key={blok._uid}>
      <img className="w-full md:w-[350px] h-[180px] rounded object-cover" 
        loading="lazy" src={`${blok.image?.filename}/m/0x240`} alt={blok.image?.alt} />
      {post_date && <div className="text-xs my-2">{post_date} - Posted</div>}
      <div className="font-serif my-2">{blok.title}</div>
      
        { 
          blok.category && blok.category.map((cat, index) => (
            <div className="flex items-center text-green-700" key={index}>
              <div className="mr-2">●</div>
              <a href={"/" + cat.full_slug} className="text-sm mr-2">{cat.name}</a>
            </div>
          ))
        }
      
      <div className="tags flex flex-wrap mt-2 justify-start">
        { 
          blok.label?.value?.length > 0 && 
          <img className="w-4 h-4 align-middle mr-2" src="/icons/tag.svg" alt="Tag icon"/>
        }
        {
          blok.label?.value?.map((tag, index) => (
            <div className="text-blue-700 text-xs border-b-2 border-blue-700 mr-2" key={index}>
              <a href={`${lang}/blogs?label=${tag}`}>{tag}</a>
            </div>
          ))
        }
      </div>
      <div className="text-sm my-4 line-clamp-5">
        {blok.excerpt}
      </div>
      <a href={"/" + full_slug} className="text-blue-800 text-sm flex items-center mt-6">{Trans('readMore')}<img className="w-5 h-atuo align-middle ml-1" src="/icons/arrow-right-blue.svg" alt="Arrow right"/></a>
    </div>
  )

  return (
    <>
      <style>
        {`
          .popular-article-section .slick-list {
            margin: 1rem 3rem 3rem; 
          }
          @media screen and (max-width: 768px) {
            .popular-article-section .slick-list {
              margin: 1rem 1rem 3rem; 
            }
            .popular-article-section .slick-arrow {
                display: none !important;
            }
          }
        `}
      </style>
      <section className="popular-article-section max-w-screen-2xl mx-auto mt-24 mb-12" {...storyblokEditable(blok)}>
        <h2 className="flex justify-center font-bold text-3xl md:text-4xl my-6 md:my-10">{blok.title}</h2>
        <div className="p-0 md:px-12 lg:px-14 mx-auto">
          <div className="slider-container">
            <div className="flex justify-center gap-2 md:hidden">
              <button className="button slick-arrow-mobile block" onClick={previous}>
                <img className="w-12" src="/icons/carousel-arrow-left.svg" alt="Prev button"/>
                <div className="text-xs">Go back</div>
              </button>
              <button className="button slick-arrow-mobile block" onClick={next}>
                <img className="w-12" src="/icons/carousel-arrow-right.svg" alt="Next button"/>
                <div className="text-xs">Next</div>
              </button>
            </div>
            <Slider ref={sliderRef} {...settings} >{articles.edges.map(e => (articleItem(e.node.content, e.node.full_slug, e.node.first_published_at)))}</Slider>
          </div>
        </div>
        <div className="flex justify-center">
          <a href={Href(blok.ctaUrl)} className="text-lg text-blue-700 border-2 border-blue-700 rounded-lg py-2 px-8 flex items-center">
            {blok.ctaText}
            <img className="w-8 h-3 align-middle ml-4" src="/icons/arrow-right-blue.svg" alt="Arrow right"/>
          </a>
        </div>
      </section>
    </>
  )
}
  
export default PopularArticle
